import { stats } from "@/mocks/products";

export default function StatsBar() {
  return (
    <section className="bg-amber-400">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-8 py-6 grid grid-cols-2 md:grid-cols-4 gap-4">
        {stats.map((s) => (
          <div key={s.label} className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full shrink-0">
              <i className={`${s.icon} text-white text-lg`}></i>
            </div>
            <div>
              <div className="text-white font-extrabold text-xl leading-tight">{s.value}</div>
              <div className="text-amber-100 text-xs">{s.label}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
